import { SERVER_FILE_ENDPOINT } from 'constants/envs';
import { AttendanceUser } from 'types/attendance';

/**
 * Ảnh đại diện: DB lưu khoá tương đối (vd "demo/avatars/abc.jpg") → ghép với máy chủ tệp như các
 * trang khác; URL đầy đủ giữ nguyên.
 */
export function attendanceAvatarUrl(user?: AttendanceUser | null): string | undefined {
  const raw = user?.profile?.avatar?.trim();
  if (!raw) return undefined;
  if (/^(https?:|data:|blob:)/i.test(raw) || raw.startsWith('//')) return raw;
  return `${SERVER_FILE_ENDPOINT}/${raw.replace(/^\/+/, '')}`;
}

/** Họ tên theo thứ tự tiếng Việt: họ + đệm (lastName) rồi tên (firstName). */
export function attendanceFullName(user?: AttendanceUser | null): string {
  if (!user) return '';
  return [user.lastName, user.firstName]
    .map((part) => (part || '').trim())
    .filter(Boolean)
    .join(' ');
}

/** Tên để hiển thị/đối chiếu với ảnh: họ tên → biệt danh → TikTok ID. */
export function attendancePersonName(user?: AttendanceUser | null): string {
  if (!user) return '';
  return (
    attendanceFullName(user) || user.nickName?.trim() || user.username?.trim() || user.email || ''
  );
}
